import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import DashboardNav from '../../components/dashboard-nav/DashboardNav';
import DashboardPageLayout from '../dashboard/dashboardPageLayout';

const settingsTabs = [
  { name: 'Overview', href: '/dashboard/settings/overview', current: true },
  { name: 'Plan & Billing', href: '/dashboard/settings/plan', current: false },
  { name: 'Integrations', href: '/dashboard/settings/integrations', current: false },
];

interface SettingsPageLayoutProps {
  title: string;
  children: ReactNode;
}

export default function SettingsPageLayout(props: SettingsPageLayoutProps) {
  return (
    <DashboardPageLayout title={props.title}>
      <div className="flex flex-1 flex-col">
        <DashboardNav className="md:hidden">
          <div className="flex-1 flex">
            <h1 className="text-lg font-bold m-0 text-gray-900">Settings</h1>
          </div>
        </DashboardNav>

        <main className="flex flex-1 flex-col w-full overflow-y-auto focus:outline-hidden">
          <div className="relative md:max-w-2xl pb-8 md:px-8 md:pt-10 md:pb-16">
            {/* Settings Nav Tabs */}
            <div className="border-b border-gray-200 w-full">
              <div className="md:flex md:items-baseline">
                <h3 className="hidden md:flex text-lg leading-6 font-bold text-gray-900">
                  Settings
                </h3>
                <div className="mt-4 md:mt-0 md:ml-10">
                  <nav className="-mb-px flex space-x-8">
                    {settingsTabs.map(tab => (
                      <NavLink
                        key={tab.name}
                        to={tab.href}
                        activeClassName="border-secondary text-secondary hover:text-secondary-dark"
                        className="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm hover:no-underline"
                      >
                        {tab.name}
                      </NavLink>
                    ))}
                  </nav>
                </div>
              </div>
            </div>

            {/* Settings Page Main Content*/}
            <div className="px-4 sm:px-6 md:px-0">{props.children}</div>
          </div>
        </main>
      </div>
    </DashboardPageLayout>
  );
}
